import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormErrorIcon, FormErrorMessage as ChakraFormErrorMessage, } from '@chakra-ui/react';
import { BxsErrorCircle } from '../../icons';
/**
 * @precondition This element should be instantiated as a child of ChakraUI's
 * `FormControl` element, and `FormControl` must have an `isInvalid = true` prop
 * before this element will be displayed.
 *
 * Used to provide feedback about an invalid input, and suggest clear instructions on how to fix it.
 */
export const FormErrorMessage = ({ children, ...props }) => {
    return (_jsxs(ChakraFormErrorMessage, { alignItems: "top", ...props, children: [_jsx(FormErrorIcon, { as: BxsErrorCircle }), children] }));
};
